import type { StatusTone } from './status';

/** One bucket of a metric series, already scaled for display. */
export interface ChartPoint {
  t: number;
  avg: number;
  min: number;
  max: number;
  polls: number;
}

export interface ChartThreshold {
  value: number;
  label: string;
  tone: StatusTone;
}

/** A moment worth marking on the time axis, e.g. an alert that was sent. */
export interface ChartMarker {
  t: number;
  tone: StatusTone;
  label: string;
}

/** Index of the point closest in time to `t` (points sorted by time), or null if there are none. */
export function nearestIndex(points: ChartPoint[], t: number): number | null {
  if (!points.length) return null;
  let lo = 0;
  let hi = points.length - 1;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (points[mid]!.t < t) lo = mid + 1;
    else hi = mid;
  }
  const prev = points[lo - 1];
  return prev && t - prev.t < points[lo]!.t - t ? lo - 1 : lo;
}
